import React from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import Fondo from "../../assets/img/fondo2.jpeg";
import MapCat from "../MapasUtils/MapCat";

const Layout = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background-image: url(${Fondo});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

const MainContent = styled("div")`
  z-index: 2;
  position: relative;
  text-align: center;
  padding: 20px;
`;

function ContenedorMapHome() {
  return (
    <Layout>
      <MainContent>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: "#fff",
            mb: 1,
          }}
        >
          Puedes explorar varios lugares
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            color: "#edf0f7ff",
            mb: 3,
          }}
        >
          La mejor plataforma para informarte sobre hoteles,
          restaurantes y zonas turísticas en Juliaca - Perú.
        </Typography>

        <MapCat />
      </MainContent>
    </Layout>
  );
}

export default ContenedorMapHome;
